import './NotificationsChangeLog.scss';

import bem from '../../utils/bem';
import NotificationsList from './NotificationList/NotificationsList';
import type { NotificationsChangeLogProps } from './types';

const NotificationsChangeLog = ({
  loading,
  toggles,
  toggleAt,
  filteredLogsToShow,
  toggleCheckedAt,
  toggleCheckedAll,
  checkedIds,
  name,
  onNext,
  hasMore,
}: NotificationsChangeLogProps): JSX.Element => {
  const [block, element] = bem('notifications-change-log-wrapper');

  try {
    return (
      <div className={block()}>
        <div className={element('notification-changelog-table-header')}>
          <span>{name}</span>
          <div>
            <label className={element('select-all')}>
              <input
                type="checkbox"
                data-testid="select-all-checkbox"
                checked={checkedIds.length === filteredLogsToShow.length && filteredLogsToShow.length > 0}
                onChange={(e): void => {
                  if (e.target.checked) {
                    toggleCheckedAll?.(true);
                  } else {
                    toggleCheckedAll?.(false);
                  }
                }}
              />{' '}
              Select All
            </label>
          </div>
        </div>
        <NotificationsList
          loading={loading}
          filteredLogsToShow={filteredLogsToShow}
          onNext={onNext}
          hasMore={hasMore}
          toggles={toggles}
          toggleAt={toggleAt}
          toggleCheckedAt={toggleCheckedAt}
          checkedIds={checkedIds}
        />
      </div>
    );
  } catch (error) {
    console.error('NotificationsChangeLog error:', error);
    return <div>Changelog has crashed.</div>;
  }
};

export default NotificationsChangeLog;
